<template>
  <div>
    <p
      class="mb-0 py-4"
      v-if="showType == 'form-builder'"
      :style="properties.style"
      v-html-sanitize="$sanitize(properties.value)"
    ></p>
    <div v-if="showType == 'properties'">
      <text-v1-properties :formId="formId" />
    </div>
    <p    
      v-show="!computedHidden"
      class="mb-0"
      v-if="((showType == 'form-submitter' && page == currentPage) || showType == 'e-form')"
      :style="properties.style"
      v-html-sanitize="sanitizeSuperComputeFormSubmitterValue"
    ></p>
    <p
      class="mb-0"
      v-if="showType == 'form-viewer'"
      :style="properties.style"
      v-html-sanitize="sanitizeSuperComputeFormSubmitterValue"
    ></p>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import TextV1Properties from "./TextV1Properties.vue";
export default {
  name: "TextV1",
  components: { TextV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["value", "hidden"],
      computedConditions: {}
    };
  },
  mounted() {
    if(this.componentsIdSuffix) {
      this.initializeComponentValue({
        controlId: this.id,
        properties: this.properties
      });
    }
    this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );
      const hideOnView = this.getComponentComputedProperties(
        "hideOnView"
      );
      
      if(hidden === true || hideOnView)
        return "";

      return `
      <div class="mb-0 form-group text-component" style="${this.getComponentComputedProperties(
        "style"
      )}">
        ${this.getComponentComputedProperties("value")}
      </div>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
    ]),
    ...mapState("formSubmitter", {
      currentPage: state => state.form.currentPage
    }),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    sanitizeSuperComputeFormSubmitterValue() {
      const result = this.computedPropertiesForm.value;

      return this.$sanitize(result);
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden
      if(this.properties.hideOnEdit) {
        return true
      }
      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
